import { authFetch } from './fetchWithAuth'
import type { Kostenuebernahme, KostenuebernahmeAuditEntry } from '../types/kostenuebernahme'

export async function listKostenuebernahmen(params: {
  status?: string
  q?: string
  skip?: number
  limit?: number
}) {
  const qs = new URLSearchParams()
  if (params.status) qs.set('status', params.status)
  if (params.q) qs.set('q', params.q)
  qs.set('skip', String(params.skip ?? 0))
  qs.set('limit', String(params.limit ?? 50))
  const r = await authFetch(`/api/superadmin/kostenuebernahmen?${qs}`)
  if (!r.ok) throw new Error(`Liste laden fehlgeschlagen: ${r.status}`)
  return r.json() as Promise<{ items: Kostenuebernahme[]; total: number }>
}

export async function getKostenuebernahmeDetail(id: number) {
  const r = await authFetch(`/api/superadmin/kostenuebernahmen/${id}`)
  if (!r.ok) throw new Error(`Detail laden fehlgeschlagen: ${r.status}`)
  return r.json() as Promise<{ item: Kostenuebernahme; audit: KostenuebernahmeAuditEntry[] }>
}

export async function updateEmpfaenger(
  id: number,
  body: { Firma: string; ApName: string; ApEmail: string },
) {
  const r = await authFetch(`/api/superadmin/kostenuebernahmen/${id}/empfaenger`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
  if (!r.ok) throw new Error(`Empfänger-Update fehlgeschlagen: ${r.status}`)
}

export async function sendErklaerung(id: number) {
  const r = await authFetch(`/api/superadmin/kostenuebernahmen/${id}/send`, {
    method: 'POST',
  })
  if (!r.ok) throw new Error(`Senden fehlgeschlagen: ${r.status}`)
}

export async function reissueErklaerung(id: number) {
  const r = await authFetch(`/api/superadmin/kostenuebernahmen/${id}/reissue`, {
    method: 'POST',
  })
  if (!r.ok) throw new Error(`Erneut senden fehlgeschlagen: ${r.status}`)
}

export async function cancelErklaerung(id: number, reason: string) {
  const r = await authFetch(`/api/superadmin/kostenuebernahmen/${id}/cancel`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ Reason: reason }),
  })
  if (!r.ok) throw new Error(`Stornieren fehlgeschlagen: ${r.status}`)
}

export async function rematchErklaerung(id: number) {
  const r = await authFetch(`/api/superadmin/kostenuebernahmen/${id}/rematch`, {
    method: 'POST',
  })
  if (!r.ok) throw new Error(`Rematch fehlgeschlagen: ${r.status}`)
}

export async function rematchAllUnmatched(limit: number = 100) {
  const r = await authFetch(`/api/superadmin/kostenuebernahmen/rematch-all?limit=${limit}`, {
    method: 'POST',
  })
  if (!r.ok) throw new Error(`Rematch-All fehlgeschlagen: ${r.status}`)
  return r.json() as Promise<{
    started: boolean
    limit: number
    message: string
  }>
}

export async function resendBuchhaltung(id: number) {
  const r = await authFetch(`/api/superadmin/kostenuebernahmen/${id}/buchhaltung-resend`, {
    method: 'POST',
  })
  if (!r.ok) throw new Error(`Buchhaltungs-Resend fehlgeschlagen: ${r.status}`)
}

export function pdfDownloadUrl(id: number) {
  return `/api/superadmin/kostenuebernahmen/${id}/pdf`
}

// ── Phase I + J: Eskalations-Inbox-Sichten ──────────────────────────────────

export async function listFirmenOhneAdmin(params: { skip?: number; limit?: number } = {}) {
  const qs = new URLSearchParams()
  qs.set('skip', String(params.skip ?? 0))
  qs.set('limit', String(params.limit ?? 50))
  const r = await authFetch(`/api/superadmin/kostenuebernahmen/firmen-ohne-admin?${qs}`)
  if (!r.ok) throw new Error(`Firmen ohne Admin laden fehlgeschlagen: ${r.status}`)
  return r.json() as Promise<{ items: Kostenuebernahme[] }>
}

export async function listAdminApprovalOverdue(params: { skip?: number; limit?: number } = {}) {
  const qs = new URLSearchParams()
  qs.set('skip', String(params.skip ?? 0))
  qs.set('limit', String(params.limit ?? 50))
  const r = await authFetch(`/api/superadmin/kostenuebernahmen/admin-approval-overdue?${qs}`)
  if (!r.ok) throw new Error(`Approval-Overdue laden fehlgeschlagen: ${r.status}`)
  return r.json() as Promise<{ items: Kostenuebernahme[] }>
}

export async function sendAdminApprovalMahnung(id: number) {
  const r = await authFetch(`/api/superadmin/kostenuebernahmen/${id}/admin-approval-mahnung`, {
    method: 'POST',
  })
  if (!r.ok) throw new Error(`Mahnungs-Versand fehlgeschlagen: ${r.status}`)
}
